/* eslint-disable no-tabs */
/* eslint-disable no-irregular-whitespace */
// LMSC-58940-User Story - Navigation Menu - Landing Page - “Dropdown list” Menu Items
// – Branch Admin user based on Profile Configuration

export interface IBranchAdminPageAccessRights {
    OfferMenu: string
    RequestASpotRate: string
    ACSpotRateOffers: string
    AISpotRateOffers: string
    MHSpotRateOffers: string
    NZSpotRateOffers: string
    SKSpotRateOffers: string
    UWSpotRateOffers: string
    Marketplace: string
    Booking: string
    SearchAvailabilityAndPrice: string
    SearchAvailableSpace: string
    SearchAirWaybillStock: string
    CreateModifyBookingNew: string
    CreateModifyBookingOld: string
    CreateMultipleBookings: string
    CreateModifyBookingTemplates: string
    CreateRecurringBookingTemplate: string
    CreateSpreadsheetBookings: string
    CreateAirWaybillStockRequest: string
    CreateAllotmentRequest: string
    ViewAllotmentStatus: string
    ViewRateEstimate: string
    ViewCarrierSchedules: string
    Efreight: string
    CreateRetrieveMAWB: string
    RetrieveeDocs: string
    CreateModifyHAWB: string
    CreateModifyHAWBTemplates: string
    CreateModifyPieceIDInfo: string
    ManageShipments: string
    TrackShipments: string
    SearchAirWaybills: string
    ViewModifyBooking: string
    ReviewActiveQueuedBookings: string
    PrintBarcodeShippingLabel: string
    PrintShipperLetterOfInstruction: string
    MakeOnlinePayments: string
    ViewFlightStatus: string
    ViewCustomsStatus: string
    ViewArchivedAirWaybill: string
    ShipmentReleaseDeclaration: string
    Edocs: string
    MyBookingDocuments: string
    AirWaybillDocuments: string
    Efinance: string
    ViewInvoices: string
    ViewPaymentDetails: string
    eClaims: string
    CreateModifyPreliminaryClaim: string
    CreateModifyFinalClaim: string
    ViewACClaimStatus: string
    ViewAIClaimStatus: string
    ViewMHClaimStatus: string
    ViewSKClaimStatus: string
}

export interface IBranchAdminAuthorizationConfig {
    isBranchMemberStatus: boolean
    isBranchAdministratorStatus: boolean
    isCoLoaderStatus: boolean
    isBookingAuthorization: boolean
    isRateAuthorization: boolean
    isAllocationAuthorization: boolean
}

const AdminPrevilages = () => {
    const adminConfigKey1: IBranchAdminAuthorizationConfig = {
        isBranchMemberStatus: true,
        isBranchAdministratorStatus: true,
        isCoLoaderStatus: false,
        isBookingAuthorization: true,
        isRateAuthorization: true,
        isAllocationAuthorization: true
    }

    const adminConfigValue1: IBranchAdminPageAccessRights = {
        OfferMenu: 'Y',
        RequestASpotRate: 'Y',
        ACSpotRateOffers: 'Y',
        AISpotRateOffers: 'Y',
        MHSpotRateOffers: 'Y',
        NZSpotRateOffers: 'Y',
        SKSpotRateOffers: 'Y',
        UWSpotRateOffers: 'Y',
        Marketplace: 'Y',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'Y',
        SearchAvailableSpace: 'Y',
        SearchAirWaybillStock: 'Y',
        CreateModifyBookingNew: 'Y',
        CreateModifyBookingOld: 'Y',
        CreateMultipleBookings: 'Y',
        CreateModifyBookingTemplates: 'Y',
        CreateRecurringBookingTemplate: 'Y',
        CreateSpreadsheetBookings: 'Y',
        CreateAirWaybillStockRequest: 'Y',
        CreateAllotmentRequest: 'Y',
        ViewAllotmentStatus: 'Y',
        ViewRateEstimate: 'Y',
        ViewCarrierSchedules: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'Y',
        RetrieveeDocs: 'Y',
        CreateModifyHAWB: 'Y',
        CreateModifyHAWBTemplates: 'Y',
        CreateModifyPieceIDInfo: 'Y',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'Y',
        ViewModifyBooking: 'Y',
        ReviewActiveQueuedBookings: 'Y',
        PrintBarcodeShippingLabel: 'Y',
        PrintShipperLetterOfInstruction: 'Y',
        MakeOnlinePayments: 'Y',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'Y',
        ViewArchivedAirWaybill: 'Y',
        ShipmentReleaseDeclaration: 'Y',
        Edocs: 'Y',
        MyBookingDocuments: 'Y',
        AirWaybillDocuments: 'Y',
        Efinance: 'Y',
        ViewInvoices: 'Y',
        ViewPaymentDetails: 'Y',
        eClaims: 'Y',
        CreateModifyPreliminaryClaim: 'Y',
        CreateModifyFinalClaim: 'Y',
        ViewACClaimStatus: 'Y',
        ViewAIClaimStatus: 'Y',
        ViewMHClaimStatus: 'Y',
        ViewSKClaimStatus: 'Y'
    }

    // Create more BranchAdminAuthorizationConfig instances for other configurations

    const adminConfigKey2: IBranchAdminAuthorizationConfig = {
        isBranchMemberStatus: true,
        isBranchAdministratorStatus: true,
        isCoLoaderStatus: false,
        isBookingAuthorization: false,
        isRateAuthorization: true,
        isAllocationAuthorization: true
    }

    const adminConfigValue2: IBranchAdminPageAccessRights = {
        OfferMenu: 'Y',
        RequestASpotRate: 'Y',
        ACSpotRateOffers: 'Y',
        AISpotRateOffers: 'Y',
        MHSpotRateOffers: 'Y',
        NZSpotRateOffers: 'Y',
        SKSpotRateOffers: 'Y',
        UWSpotRateOffers: 'Y',
        Marketplace: 'Y',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'Y',
        SearchAvailableSpace: 'Y',
        SearchAirWaybillStock: 'N',
        CreateModifyBookingNew: 'N',
        CreateModifyBookingOld: 'N',
        CreateMultipleBookings: 'N',
        CreateModifyBookingTemplates: 'N',
        CreateRecurringBookingTemplate: 'N',
        CreateSpreadsheetBookings: 'N',
        CreateAirWaybillStockRequest: 'N',
        CreateAllotmentRequest: 'Y',
        ViewAllotmentStatus: 'Y',
        ViewRateEstimate: 'Y',
        ViewCarrierSchedules: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'Y',
        RetrieveeDocs: 'Y',
        CreateModifyHAWB: 'Y',
        CreateModifyHAWBTemplates: 'Y',
        CreateModifyPieceIDInfo: 'Y',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'Y',
        ViewModifyBooking: 'N',
        ReviewActiveQueuedBookings: 'N',
        PrintBarcodeShippingLabel: 'N',
        PrintShipperLetterOfInstruction: 'N',
        MakeOnlinePayments: 'N',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'Y',
        ViewArchivedAirWaybill: 'Y',
        ShipmentReleaseDeclaration: 'Y',
        Edocs: 'Y',
        MyBookingDocuments: 'Y',
        AirWaybillDocuments: 'Y',
        Efinance: 'Y',
        ViewInvoices: 'Y',
        ViewPaymentDetails: 'Y',
        eClaims: 'Y',
        CreateModifyPreliminaryClaim: 'Y',
        CreateModifyFinalClaim: 'Y',
        ViewACClaimStatus: 'Y',
        ViewAIClaimStatus: 'Y',
        ViewMHClaimStatus: 'Y',
        ViewSKClaimStatus: 'Y'
    }

    const adminConfigKey3: IBranchAdminAuthorizationConfig = {
        isBranchMemberStatus: true,
        isBranchAdministratorStatus: true,
        isCoLoaderStatus: false,
        isBookingAuthorization: true,
        isRateAuthorization: false,
        isAllocationAuthorization: true
    }

    const adminConfigValue3: IBranchAdminPageAccessRights = {
        OfferMenu: 'Y',
        RequestASpotRate: 'Y',
        ACSpotRateOffers: 'Y',
        AISpotRateOffers: 'Y',
        MHSpotRateOffers: 'Y',
        NZSpotRateOffers: 'Y',
        SKSpotRateOffers: 'Y',
        UWSpotRateOffers: 'Y',
        Marketplace: 'N',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'Y',
        SearchAvailableSpace: 'Y',
        SearchAirWaybillStock: 'Y',
        CreateModifyBookingNew: 'Y',
        CreateModifyBookingOld: 'Y',
        CreateMultipleBookings: 'Y',
        CreateModifyBookingTemplates: 'Y',
        CreateRecurringBookingTemplate: 'Y',
        CreateSpreadsheetBookings: 'Y',
        CreateAirWaybillStockRequest: 'Y',
        CreateAllotmentRequest: 'Y',
        ViewAllotmentStatus: 'Y',
        ViewRateEstimate: 'N',
        ViewCarrierSchedules: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'Y',
        RetrieveeDocs: 'Y',
        CreateModifyHAWB: 'Y',
        CreateModifyHAWBTemplates: 'Y',
        CreateModifyPieceIDInfo: 'Y',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'Y',
        ViewModifyBooking: 'Y',
        ReviewActiveQueuedBookings: 'Y',
        PrintBarcodeShippingLabel: 'Y',
        PrintShipperLetterOfInstruction: 'Y',
        MakeOnlinePayments: 'Y',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'Y',
        ViewArchivedAirWaybill: 'Y',
        ShipmentReleaseDeclaration: 'Y',
        Edocs: 'Y',
        MyBookingDocuments: 'Y',
        AirWaybillDocuments: 'Y',
        Efinance: 'Y',
        ViewInvoices: 'Y',
        ViewPaymentDetails: 'Y',
        eClaims: 'Y',
        CreateModifyPreliminaryClaim: 'Y',
        CreateModifyFinalClaim: 'Y',
        ViewACClaimStatus: 'Y',
        ViewAIClaimStatus: 'Y',
        ViewMHClaimStatus: 'Y',
        ViewSKClaimStatus: 'Y'
    }

    const adminConfigKey4: IBranchAdminAuthorizationConfig = {
        isBranchMemberStatus: true,
        isBranchAdministratorStatus: true,
        isCoLoaderStatus: false,
        isBookingAuthorization: true,
        isRateAuthorization: true,
        isAllocationAuthorization: false
    }

    const adminConfigValue4: IBranchAdminPageAccessRights = {
        OfferMenu: 'Y',
        RequestASpotRate: 'Y',
        ACSpotRateOffers: 'Y',
        AISpotRateOffers: 'Y',
        MHSpotRateOffers: 'Y',
        NZSpotRateOffers: 'Y',
        SKSpotRateOffers: 'Y',
        UWSpotRateOffers: 'Y',
        Marketplace: 'Y',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'Y',
        SearchAvailableSpace: 'Y',
        SearchAirWaybillStock: 'Y',
        CreateModifyBookingNew: 'Y',
        CreateModifyBookingOld: 'Y',
        CreateMultipleBookings: 'Y',
        CreateModifyBookingTemplates: 'Y',
        CreateRecurringBookingTemplate: 'Y',
        CreateSpreadsheetBookings: 'Y',
        CreateAirWaybillStockRequest: 'Y',
        CreateAllotmentRequest: 'N',
        ViewAllotmentStatus: 'N',
        ViewRateEstimate: 'Y',
        ViewCarrierSchedules: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'Y',
        RetrieveeDocs: 'Y',
        CreateModifyHAWB: 'Y',
        CreateModifyHAWBTemplates: 'Y',
        CreateModifyPieceIDInfo: 'Y',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'Y',
        ViewModifyBooking: 'Y',
        ReviewActiveQueuedBookings: 'Y',
        PrintBarcodeShippingLabel: 'Y',
        PrintShipperLetterOfInstruction: 'Y',
        MakeOnlinePayments: 'Y',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'Y',
        ViewArchivedAirWaybill: 'Y',
        ShipmentReleaseDeclaration: 'Y',
        Edocs: 'Y',
        MyBookingDocuments: 'Y',
        AirWaybillDocuments: 'Y',
        Efinance: 'Y',
        ViewInvoices: 'Y',
        ViewPaymentDetails: 'Y',
        eClaims: 'Y',
        CreateModifyPreliminaryClaim: 'Y',
        CreateModifyFinalClaim: 'Y',
        ViewACClaimStatus: 'Y',
        ViewAIClaimStatus: 'Y',
        ViewMHClaimStatus: 'Y',
        ViewSKClaimStatus: 'Y'
    }

    const adminConfigKey5: IBranchAdminAuthorizationConfig = {
        isBranchMemberStatus: true,
        isBranchAdministratorStatus: true,
        isCoLoaderStatus: false,
        isBookingAuthorization: false,
        isRateAuthorization: false,
        isAllocationAuthorization: false
    }

    const adminConfigValue5: IBranchAdminPageAccessRights = {
        OfferMenu: 'Y',
        RequestASpotRate: 'Y',
        ACSpotRateOffers: 'Y',
        AISpotRateOffers: 'Y',
        MHSpotRateOffers: 'Y',
        NZSpotRateOffers: 'Y',
        SKSpotRateOffers: 'Y',
        UWSpotRateOffers: 'Y',
        Marketplace: 'N',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'Y',
        SearchAvailableSpace: 'Y',
        SearchAirWaybillStock: 'N',
        CreateModifyBookingNew: 'N',
        CreateModifyBookingOld: 'N',
        CreateMultipleBookings: 'N',
        CreateModifyBookingTemplates: 'N',
        CreateRecurringBookingTemplate: 'N',
        CreateSpreadsheetBookings: 'N',
        CreateAirWaybillStockRequest: 'N',
        CreateAllotmentRequest: 'N',
        ViewAllotmentStatus: 'N',
        ViewRateEstimate: 'N',
        ViewCarrierSchedules: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'Y',
        RetrieveeDocs: 'Y',
        CreateModifyHAWB: 'Y',
        CreateModifyHAWBTemplates: 'Y',
        CreateModifyPieceIDInfo: 'Y',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'Y',
        ViewModifyBooking: 'N',
        ReviewActiveQueuedBookings: 'N',
        PrintBarcodeShippingLabel: 'N',
        PrintShipperLetterOfInstruction: 'N',
        MakeOnlinePayments: 'N',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'Y',
        ViewArchivedAirWaybill: 'Y',
        ShipmentReleaseDeclaration: 'Y',
        Edocs: 'Y',
        MyBookingDocuments: 'Y',
        AirWaybillDocuments: 'Y',
        Efinance: 'Y',
        ViewInvoices: 'Y',
        ViewPaymentDetails: 'Y',
        eClaims: 'Y',
        CreateModifyPreliminaryClaim: 'Y',
        CreateModifyFinalClaim: 'Y',
        ViewACClaimStatus: 'Y',
        ViewAIClaimStatus: 'Y',
        ViewMHClaimStatus: 'Y',
        ViewSKClaimStatus: 'Y'
    }

    const adminConfigKey6: IBranchAdminAuthorizationConfig = {
        isBranchMemberStatus: true,
        isBranchAdministratorStatus: false,
        isCoLoaderStatus: false,
        isBookingAuthorization: true,
        isRateAuthorization: true,
        isAllocationAuthorization: true
    }

    const adminConfigValue6: IBranchAdminPageAccessRights = {
        OfferMenu: 'Y',
        RequestASpotRate: 'Y',
        ACSpotRateOffers: 'Y',
        AISpotRateOffers: 'Y',
        MHSpotRateOffers: 'Y',
        NZSpotRateOffers: 'Y',
        SKSpotRateOffers: 'Y',
        UWSpotRateOffers: 'Y',
        Marketplace: 'Y',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'Y',
        SearchAvailableSpace: 'Y',
        SearchAirWaybillStock: 'Y',
        CreateModifyBookingNew: 'Y',
        CreateModifyBookingOld: 'Y',
        CreateMultipleBookings: 'Y',
        CreateModifyBookingTemplates: 'Y',
        CreateRecurringBookingTemplate: 'Y',
        CreateSpreadsheetBookings: 'Y',
        CreateAirWaybillStockRequest: 'Y',
        CreateAllotmentRequest: 'Y',
        ViewAllotmentStatus: 'Y',
        ViewRateEstimate: 'Y',
        ViewCarrierSchedules: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'Y',
        RetrieveeDocs: 'Y',
        CreateModifyHAWB: 'Y',
        CreateModifyHAWBTemplates: 'Y',
        CreateModifyPieceIDInfo: 'Y',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'Y',
        ViewModifyBooking: 'Y',
        ReviewActiveQueuedBookings: 'Y',
        PrintBarcodeShippingLabel: 'Y',
        PrintShipperLetterOfInstruction: 'Y',
        MakeOnlinePayments: 'Y',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'Y',
        ViewArchivedAirWaybill: 'Y',
        ShipmentReleaseDeclaration: 'Y',
        Edocs: 'Y',
        MyBookingDocuments: 'Y',
        AirWaybillDocuments: 'Y',
        Efinance: 'Y',
        ViewInvoices: 'Y',
        ViewPaymentDetails: 'Y',
        eClaims: 'Y',
        CreateModifyPreliminaryClaim: 'Y',
        CreateModifyFinalClaim: 'Y',
        ViewACClaimStatus: 'Y',
        ViewAIClaimStatus: 'Y',
        ViewMHClaimStatus: 'Y',
        ViewSKClaimStatus: 'Y'
    }

    const adminConfigKey7: IBranchAdminAuthorizationConfig = {
        isBranchMemberStatus: false,
        isBranchAdministratorStatus: true,
        isCoLoaderStatus: false,
        isBookingAuthorization: true,
        isRateAuthorization: true,
        isAllocationAuthorization: true
    }

    const adminConfigValue7: IBranchAdminPageAccessRights = {
        OfferMenu: 'N',
        RequestASpotRate: 'N',
        ACSpotRateOffers: 'N',
        AISpotRateOffers: 'N',
        MHSpotRateOffers: 'N',
        NZSpotRateOffers: 'N',
        SKSpotRateOffers: 'N',
        UWSpotRateOffers: 'N',
        Marketplace: 'N',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'N',
        SearchAvailableSpace: 'N',
        SearchAirWaybillStock: 'N',
        CreateModifyBookingNew: 'N',
        CreateModifyBookingOld: 'N',
        CreateMultipleBookings: 'N',
        CreateModifyBookingTemplates: 'N',
        CreateRecurringBookingTemplate: 'N',
        CreateSpreadsheetBookings: 'N',
        CreateAirWaybillStockRequest: 'N',
        CreateAllotmentRequest: 'N',
        ViewAllotmentStatus: 'N',
        ViewRateEstimate: 'N',
        ViewCarrierSchedules: 'N',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'N',
        RetrieveeDocs: 'N',
        CreateModifyHAWB: 'N',
        CreateModifyHAWBTemplates: 'N',
        CreateModifyPieceIDInfo: 'N',
        ManageShipments: 'Y',
        TrackShipments: 'N',
        SearchAirWaybills: 'N',
        ViewModifyBooking: 'N',
        ReviewActiveQueuedBookings: 'N',
        PrintBarcodeShippingLabel: 'N',
        PrintShipperLetterOfInstruction: 'N',
        MakeOnlinePayments: 'N',
        ViewFlightStatus: 'N',
        ViewCustomsStatus: 'N',
        ViewArchivedAirWaybill: 'N',
        ShipmentReleaseDeclaration: 'N',
        Edocs: 'Y',
        MyBookingDocuments: 'N',
        AirWaybillDocuments: 'N',
        Efinance: 'Y',
        ViewInvoices: 'N',
        ViewPaymentDetails: 'N',
        eClaims: 'Y',
        CreateModifyPreliminaryClaim: 'N',
        CreateModifyFinalClaim: 'N',
        ViewACClaimStatus: 'N',
        ViewAIClaimStatus: 'N',
        ViewMHClaimStatus: 'N',
        ViewSKClaimStatus: 'N'
    }

    const adminConfigKey8: IBranchAdminAuthorizationConfig = {
        isBranchMemberStatus: false,
        isBranchAdministratorStatus: false,
        isCoLoaderStatus: false,
        isBookingAuthorization: true,
        isRateAuthorization: true,
        isAllocationAuthorization: true
    }

    const adminConfigValue8: IBranchAdminPageAccessRights = {
        OfferMenu: 'N',
        RequestASpotRate: 'N',
        ACSpotRateOffers: 'N',
        AISpotRateOffers: 'N',
        MHSpotRateOffers: 'N',
        NZSpotRateOffers: 'N',
        SKSpotRateOffers: 'N',
        UWSpotRateOffers: 'N',
        Marketplace: 'N',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'N',
        SearchAvailableSpace: 'N',
        SearchAirWaybillStock: 'N',
        CreateModifyBookingNew: 'N',
        CreateModifyBookingOld: 'N',
        CreateMultipleBookings: 'N',
        CreateModifyBookingTemplates: 'N',
        CreateRecurringBookingTemplate: 'N',
        CreateSpreadsheetBookings: 'N',
        CreateAirWaybillStockRequest: 'N',
        CreateAllotmentRequest: 'N',
        ViewAllotmentStatus: 'N',
        ViewRateEstimate: 'N',
        ViewCarrierSchedules: 'N',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'N',
        RetrieveeDocs: 'N',
        CreateModifyHAWB: 'N',
        CreateModifyHAWBTemplates: 'N',
        CreateModifyPieceIDInfo: 'N',
        ManageShipments: 'Y',
        TrackShipments: 'N',
        SearchAirWaybills: 'N',
        ViewModifyBooking: 'N',
        ReviewActiveQueuedBookings: 'N',
        PrintBarcodeShippingLabel: 'N',
        PrintShipperLetterOfInstruction: 'N',
        MakeOnlinePayments: 'N',
        ViewFlightStatus: 'N',
        ViewCustomsStatus: 'N',
        ViewArchivedAirWaybill: 'N',
        ShipmentReleaseDeclaration: 'N',
        Edocs: 'Y',
        MyBookingDocuments: 'N',
        AirWaybillDocuments: 'N',
        Efinance: 'Y',
        ViewInvoices: 'N',
        ViewPaymentDetails: 'N',
        eClaims: 'Y',
        CreateModifyPreliminaryClaim: 'N',
        CreateModifyFinalClaim: 'N',
        ViewACClaimStatus: 'N',
        ViewAIClaimStatus: 'N',
        ViewMHClaimStatus: 'N',
        ViewSKClaimStatus: 'N'
    }

    const adminConfigKey9: IBranchAdminAuthorizationConfig = {
        isBranchMemberStatus: true,
        isBranchAdministratorStatus: false,
        isCoLoaderStatus: true,
        isBookingAuthorization: true,
        isRateAuthorization: true,
        isAllocationAuthorization: true
    }

    const adminConfigValue9: IBranchAdminPageAccessRights = {
        OfferMenu: 'Y',
        RequestASpotRate: 'N',
        ACSpotRateOffers: 'N',
        AISpotRateOffers: 'N',
        MHSpotRateOffers: 'N',
        NZSpotRateOffers: 'N',
        SKSpotRateOffers: 'N',
        UWSpotRateOffers: 'N',
        Marketplace: 'N',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'N',
        SearchAvailableSpace: 'N',
        SearchAirWaybillStock: 'N',
        CreateModifyBookingNew: 'N',
        CreateModifyBookingOld: 'N',
        CreateMultipleBookings: 'N',
        CreateModifyBookingTemplates: 'N',
        CreateRecurringBookingTemplate: 'N',
        CreateSpreadsheetBookings: 'N',
        CreateAirWaybillStockRequest: 'N',
        CreateAllotmentRequest: 'N',
        ViewAllotmentStatus: 'N',
        ViewRateEstimate: 'N',
        ViewCarrierSchedules: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'N',
        RetrieveeDocs: 'N',
        CreateModifyHAWB: 'N',
        CreateModifyHAWBTemplates: 'N',
        CreateModifyPieceIDInfo: 'N',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'N',
        ViewModifyBooking: 'N',
        ReviewActiveQueuedBookings: 'N',
        PrintBarcodeShippingLabel: 'Y',
        PrintShipperLetterOfInstruction: 'Y',
        MakeOnlinePayments: 'N',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'N',
        ViewArchivedAirWaybill: 'N',
        ShipmentReleaseDeclaration: 'Y',
        Edocs: 'Y',
        MyBookingDocuments: 'N',
        AirWaybillDocuments: 'N',
        Efinance: 'Y',
        ViewInvoices: 'N',
        ViewPaymentDetails: 'N',
        eClaims: 'Y',
        CreateModifyPreliminaryClaim: 'N',
        CreateModifyFinalClaim: 'N',
        ViewACClaimStatus: 'N',
        ViewAIClaimStatus: 'N',
        ViewMHClaimStatus: 'N',
        ViewSKClaimStatus: 'N'
    }

    const adminConfigKey10: IBranchAdminAuthorizationConfig = {
        isBranchMemberStatus: true,
        isBranchAdministratorStatus: true,
        isCoLoaderStatus: false,
        isBookingAuthorization: true,
        isRateAuthorization: false,
        isAllocationAuthorization: false
    }

    const adminConfigValue10: IBranchAdminPageAccessRights = {
        OfferMenu: 'Y',
        RequestASpotRate: 'Y',
        ACSpotRateOffers: 'Y',
        AISpotRateOffers: 'Y',
        MHSpotRateOffers: 'Y',
        NZSpotRateOffers: 'Y',
        SKSpotRateOffers: 'Y',
        UWSpotRateOffers: 'Y',
        Marketplace: 'N',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'Y',
        SearchAvailableSpace: 'Y',
        SearchAirWaybillStock: 'Y',
        CreateModifyBookingNew: 'Y',
        CreateModifyBookingOld: 'Y',
        CreateMultipleBookings: 'Y',
        CreateModifyBookingTemplates: 'Y',
        CreateRecurringBookingTemplate: 'Y',
        CreateSpreadsheetBookings: 'Y',
        CreateAirWaybillStockRequest: 'Y',
        CreateAllotmentRequest: 'N',
        ViewAllotmentStatus: 'N',
        ViewRateEstimate: 'N',
        ViewCarrierSchedules: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'Y',
        RetrieveeDocs: 'Y',
        CreateModifyHAWB: 'Y',
        CreateModifyHAWBTemplates: 'Y',
        CreateModifyPieceIDInfo: 'Y',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'Y',
        ViewModifyBooking: 'Y',
        ReviewActiveQueuedBookings: 'Y',
        PrintBarcodeShippingLabel: 'Y',
        PrintShipperLetterOfInstruction: 'Y',
        MakeOnlinePayments: 'Y',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'Y',
        ViewArchivedAirWaybill: 'Y',
        ShipmentReleaseDeclaration: 'Y',
        Edocs: 'Y',
        MyBookingDocuments: 'Y',
        AirWaybillDocuments: 'Y',
        Efinance: 'Y',
        ViewInvoices: 'Y',
        ViewPaymentDetails: 'Y',
        eClaims: 'Y',
        CreateModifyPreliminaryClaim: 'Y',
        CreateModifyFinalClaim: 'Y',
        ViewACClaimStatus: 'Y',
        ViewAIClaimStatus: 'Y',
        ViewMHClaimStatus: 'Y',
        ViewSKClaimStatus: 'Y'
    }

    const adminConfigKey11: IBranchAdminAuthorizationConfig = {
        isBranchMemberStatus: true,
        isBranchAdministratorStatus: true,
        isCoLoaderStatus: false,
        isBookingAuthorization: false,
        isRateAuthorization: true,
        isAllocationAuthorization: false
    }

    const adminConfigValue11: IBranchAdminPageAccessRights = {
        OfferMenu: 'Y',
        RequestASpotRate: 'Y',
        ACSpotRateOffers: 'Y',
        AISpotRateOffers: 'Y',
        MHSpotRateOffers: 'Y',
        NZSpotRateOffers: 'Y',
        SKSpotRateOffers: 'Y',
        UWSpotRateOffers: 'Y',
        Marketplace: 'Y',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'Y',
        SearchAvailableSpace: 'Y',
        SearchAirWaybillStock: 'N',
        CreateModifyBookingNew: 'N',
        CreateModifyBookingOld: 'N',
        CreateMultipleBookings: 'N',
        CreateModifyBookingTemplates: 'N',
        CreateRecurringBookingTemplate: 'N',
        CreateSpreadsheetBookings: 'N',
        CreateAirWaybillStockRequest: 'N',
        CreateAllotmentRequest: 'N',
        ViewAllotmentStatus: 'N',
        ViewRateEstimate: 'Y',
        ViewCarrierSchedules: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'Y',
        RetrieveeDocs: 'Y',
        CreateModifyHAWB: 'Y',
        CreateModifyHAWBTemplates: 'Y',
        CreateModifyPieceIDInfo: 'Y',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'Y',
        ViewModifyBooking: 'N',
        ReviewActiveQueuedBookings: 'N',
        PrintBarcodeShippingLabel: 'N',
        PrintShipperLetterOfInstruction: 'N',
        MakeOnlinePayments: 'N',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'Y',
        ViewArchivedAirWaybill: 'Y',
        ShipmentReleaseDeclaration: 'Y',
        Edocs: 'Y',
        MyBookingDocuments: 'Y',
        AirWaybillDocuments: 'Y',
        Efinance: 'Y',
        ViewInvoices: 'Y',
        ViewPaymentDetails: 'Y',
        eClaims: 'Y',
        CreateModifyPreliminaryClaim: 'Y',
        CreateModifyFinalClaim: 'Y',
        ViewACClaimStatus: 'Y',
        ViewAIClaimStatus: 'Y',
        ViewMHClaimStatus: 'Y',
        ViewSKClaimStatus: 'Y'
    }

    const adminConfigKey12: IBranchAdminAuthorizationConfig = {
        isBranchMemberStatus: true,
        isBranchAdministratorStatus: true,
        isCoLoaderStatus: false,
        isBookingAuthorization: false,
        isRateAuthorization: false,
        isAllocationAuthorization: true
    }

    const adminConfigValue12: IBranchAdminPageAccessRights = {
        OfferMenu: 'Y',
        RequestASpotRate: 'Y',
        ACSpotRateOffers: 'Y',
        AISpotRateOffers: 'Y',
        MHSpotRateOffers: 'Y',
        NZSpotRateOffers: 'Y',
        SKSpotRateOffers: 'Y',
        UWSpotRateOffers: 'Y',
        Marketplace: 'N',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'Y',
        SearchAvailableSpace: 'Y',
        SearchAirWaybillStock: 'N',
        CreateModifyBookingNew: 'N',
        CreateModifyBookingOld: 'N',
        CreateMultipleBookings: 'N',
        CreateModifyBookingTemplates: 'N',
        CreateRecurringBookingTemplate: 'N',
        CreateSpreadsheetBookings: 'N',
        CreateAirWaybillStockRequest: 'N',
        CreateAllotmentRequest: 'Y',
        ViewAllotmentStatus: 'Y',
        ViewRateEstimate: 'N',
        ViewCarrierSchedules: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'Y',
        RetrieveeDocs: 'Y',
        CreateModifyHAWB: 'Y',
        CreateModifyHAWBTemplates: 'Y',
        CreateModifyPieceIDInfo: 'Y',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'Y',
        ViewModifyBooking: 'N',
        ReviewActiveQueuedBookings: 'N',
        PrintBarcodeShippingLabel: 'N',
        PrintShipperLetterOfInstruction: 'N',
        MakeOnlinePayments: 'N',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'Y',
        ViewArchivedAirWaybill: 'Y',
        ShipmentReleaseDeclaration: 'Y',
        Edocs: 'Y',
        MyBookingDocuments: 'Y',
        AirWaybillDocuments: 'Y',
        Efinance: 'Y',
        ViewInvoices: 'Y',
        ViewPaymentDetails: 'Y',
        eClaims: 'Y',
        CreateModifyPreliminaryClaim: 'Y',
        CreateModifyFinalClaim: 'Y',
        ViewACClaimStatus: 'Y',
        ViewAIClaimStatus: 'Y',
        ViewMHClaimStatus: 'Y',
        ViewSKClaimStatus: 'Y'
    }

    const adminConfigKey13: IBranchAdminAuthorizationConfig = {
        isBranchMemberStatus: true,
        isBranchAdministratorStatus: false,
        isCoLoaderStatus: false,
        isBookingAuthorization: false,
        isRateAuthorization: true,
        isAllocationAuthorization: true
    }

    const adminConfigValue13: IBranchAdminPageAccessRights = {
        OfferMenu: 'Y',
        RequestASpotRate: 'Y',
        ACSpotRateOffers: 'Y',
        AISpotRateOffers: 'Y',
        MHSpotRateOffers: 'Y',
        NZSpotRateOffers: 'Y',
        SKSpotRateOffers: 'Y',
        UWSpotRateOffers: 'Y',
        Marketplace: 'Y',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'Y',
        SearchAvailableSpace: 'Y',
        SearchAirWaybillStock: 'N',
        CreateModifyBookingNew: 'N',
        CreateModifyBookingOld: 'N',
        CreateMultipleBookings: 'N',
        CreateModifyBookingTemplates: 'N',
        CreateRecurringBookingTemplate: 'N',
        CreateSpreadsheetBookings: 'N',
        CreateAirWaybillStockRequest: 'N',
        CreateAllotmentRequest: 'Y',
        ViewAllotmentStatus: 'Y',
        ViewRateEstimate: 'Y',
        ViewCarrierSchedules: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'Y',
        RetrieveeDocs: 'Y',
        CreateModifyHAWB: 'Y',
        CreateModifyHAWBTemplates: 'Y',
        CreateModifyPieceIDInfo: 'Y',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'Y',
        ViewModifyBooking: 'N',
        ReviewActiveQueuedBookings: 'N',
        PrintBarcodeShippingLabel: 'N',
        PrintShipperLetterOfInstruction: 'N',
        MakeOnlinePayments: 'N',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'Y',
        ViewArchivedAirWaybill: 'Y',
        ShipmentReleaseDeclaration: 'Y',
        Edocs: 'Y',
        MyBookingDocuments: 'Y',
        AirWaybillDocuments: 'Y',
        Efinance: 'Y',
        ViewInvoices: 'Y',
        ViewPaymentDetails: 'Y',
        eClaims: 'Y',
        CreateModifyPreliminaryClaim: 'Y',
        CreateModifyFinalClaim: 'Y',
        ViewACClaimStatus: 'Y',
        ViewAIClaimStatus: 'Y',
        ViewMHClaimStatus: 'Y',
        ViewSKClaimStatus: 'Y'
    }

    const adminConfigKey14: IBranchAdminAuthorizationConfig = {
        isBranchMemberStatus: true,
        isBranchAdministratorStatus: false,
        isCoLoaderStatus: false,
        isBookingAuthorization: false,
        isRateAuthorization: true,
        isAllocationAuthorization: true
    }

    const adminConfigValue14: IBranchAdminPageAccessRights = {
        OfferMenu: 'Y',
        RequestASpotRate: 'Y',
        ACSpotRateOffers: 'Y',
        AISpotRateOffers: 'Y',
        MHSpotRateOffers: 'Y',
        NZSpotRateOffers: 'Y',
        SKSpotRateOffers: 'Y',
        UWSpotRateOffers: 'Y',
        Marketplace: 'N',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'Y',
        SearchAvailableSpace: 'Y',
        SearchAirWaybillStock: 'Y',
        CreateModifyBookingNew: 'Y',
        CreateModifyBookingOld: 'Y',
        CreateMultipleBookings: 'Y',
        CreateModifyBookingTemplates: 'Y',
        CreateRecurringBookingTemplate: 'Y',
        CreateSpreadsheetBookings: 'Y',
        CreateAirWaybillStockRequest: 'Y',
        CreateAllotmentRequest: 'Y',
        ViewAllotmentStatus: 'Y',
        ViewRateEstimate: 'N',
        ViewCarrierSchedules: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'Y',
        RetrieveeDocs: 'Y',
        CreateModifyHAWB: 'Y',
        CreateModifyHAWBTemplates: 'Y',
        CreateModifyPieceIDInfo: 'Y',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'Y',
        ViewModifyBooking: 'Y',
        ReviewActiveQueuedBookings: 'Y',
        PrintBarcodeShippingLabel: 'Y',
        PrintShipperLetterOfInstruction: 'Y',
        MakeOnlinePayments: 'Y',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'Y',
        ViewArchivedAirWaybill: 'Y',
        ShipmentReleaseDeclaration: 'Y',
        Edocs: 'Y',
        MyBookingDocuments: 'Y',
        AirWaybillDocuments: 'Y',
        Efinance: 'Y',
        ViewInvoices: 'Y',
        ViewPaymentDetails: 'Y',
        eClaims: 'Y',
        CreateModifyPreliminaryClaim: 'Y',
        CreateModifyFinalClaim: 'Y',
        ViewACClaimStatus: 'Y',
        ViewAIClaimStatus: 'Y',
        ViewMHClaimStatus: 'Y',
        ViewSKClaimStatus: 'Y'
    }

    const adminConfigKey15: IBranchAdminAuthorizationConfig = {
        isBranchMemberStatus: true,
        isBranchAdministratorStatus: false,
        isCoLoaderStatus: false,
        isBookingAuthorization: true,
        isRateAuthorization: true,
        isAllocationAuthorization: false
    }

    const adminConfigValue15: IBranchAdminPageAccessRights = {
        OfferMenu: 'Y',
        RequestASpotRate: 'Y',
        ACSpotRateOffers: 'Y',
        AISpotRateOffers: 'Y',
        MHSpotRateOffers: 'Y',
        NZSpotRateOffers: 'Y',
        SKSpotRateOffers: 'Y',
        UWSpotRateOffers: 'Y',
        Marketplace: 'Y',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'Y',
        SearchAvailableSpace: 'Y',
        SearchAirWaybillStock: 'Y',
        CreateModifyBookingNew: 'Y',
        CreateModifyBookingOld: 'Y',
        CreateMultipleBookings: 'Y',
        CreateModifyBookingTemplates: 'Y',
        CreateRecurringBookingTemplate: 'Y',
        CreateSpreadsheetBookings: 'Y',
        CreateAirWaybillStockRequest: 'Y',
        CreateAllotmentRequest: 'N',
        ViewAllotmentStatus: 'N',
        ViewRateEstimate: 'Y',
        ViewCarrierSchedules: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'Y',
        RetrieveeDocs: 'Y',
        CreateModifyHAWB: 'Y',
        CreateModifyHAWBTemplates: 'Y',
        CreateModifyPieceIDInfo: 'Y',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'Y',
        ViewModifyBooking: 'Y',
        ReviewActiveQueuedBookings: 'Y',
        PrintBarcodeShippingLabel: 'Y',
        PrintShipperLetterOfInstruction: 'Y',
        MakeOnlinePayments: 'Y',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'Y',
        ViewArchivedAirWaybill: 'Y',
        ShipmentReleaseDeclaration: 'Y',
        Edocs: 'Y',
        MyBookingDocuments: 'Y',
        AirWaybillDocuments: 'Y',
        Efinance: 'Y',
        ViewInvoices: 'Y',
        ViewPaymentDetails: 'Y',
        eClaims: 'Y',
        CreateModifyPreliminaryClaim: 'Y',
        CreateModifyFinalClaim: 'Y',
        ViewACClaimStatus: 'Y',
        ViewAIClaimStatus: 'Y',
        ViewMHClaimStatus: 'Y',
        ViewSKClaimStatus: 'Y'
    }
    const adminConfigKey16: IBranchAdminAuthorizationConfig = {
        isBranchMemberStatus: true,
        isBranchAdministratorStatus: false,
        isCoLoaderStatus: false,
        isBookingAuthorization: true,
        isRateAuthorization: false,
        isAllocationAuthorization: false
    }

    const adminConfigValue16: IBranchAdminPageAccessRights = {
        OfferMenu: 'Y',
        RequestASpotRate: 'Y',
        ACSpotRateOffers: 'Y',
        AISpotRateOffers: 'Y',
        MHSpotRateOffers: 'Y',
        NZSpotRateOffers: 'Y',
        SKSpotRateOffers: 'Y',
        UWSpotRateOffers: 'Y',
        Marketplace: 'N',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'Y',
        SearchAvailableSpace: 'Y',
        SearchAirWaybillStock: 'Y',
        CreateModifyBookingNew: 'Y',
        CreateModifyBookingOld: 'Y',
        CreateMultipleBookings: 'Y',
        CreateModifyBookingTemplates: 'Y',
        CreateRecurringBookingTemplate: 'Y',
        CreateSpreadsheetBookings: 'Y',
        CreateAirWaybillStockRequest: 'Y',
        CreateAllotmentRequest: 'N',
        ViewAllotmentStatus: 'N',
        ViewRateEstimate: 'N',
        ViewCarrierSchedules: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'Y',
        RetrieveeDocs: 'Y',
        CreateModifyHAWB: 'Y',
        CreateModifyHAWBTemplates: 'Y',
        CreateModifyPieceIDInfo: 'Y',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'Y',
        ViewModifyBooking: 'Y',
        ReviewActiveQueuedBookings: 'Y',
        PrintBarcodeShippingLabel: 'Y',
        PrintShipperLetterOfInstruction: 'Y',
        MakeOnlinePayments: 'Y',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'Y',
        ViewArchivedAirWaybill: 'Y',
        ShipmentReleaseDeclaration: 'Y',
        Edocs: 'Y',
        MyBookingDocuments: 'Y',
        AirWaybillDocuments: 'Y',
        Efinance: 'Y',
        ViewInvoices: 'Y',
        ViewPaymentDetails: 'Y',
        eClaims: 'Y',
        CreateModifyPreliminaryClaim: 'Y',
        CreateModifyFinalClaim: 'Y',
        ViewACClaimStatus: 'Y',
        ViewAIClaimStatus: 'Y',
        ViewMHClaimStatus: 'Y',
        ViewSKClaimStatus: 'Y'
    }

    const adminConfigKey17: IBranchAdminAuthorizationConfig = {
        isBranchMemberStatus: true,
        isBranchAdministratorStatus: false,
        isCoLoaderStatus: false,
        isBookingAuthorization: false,
        isRateAuthorization: true,
        isAllocationAuthorization: false
    }

    const adminConfigValue17: IBranchAdminPageAccessRights = {
        OfferMenu: 'Y',
        RequestASpotRate: 'Y',
        ACSpotRateOffers: 'Y',
        AISpotRateOffers: 'Y',
        MHSpotRateOffers: 'Y',
        NZSpotRateOffers: 'Y',
        SKSpotRateOffers: 'Y',
        UWSpotRateOffers: 'Y',
        Marketplace: 'Y',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'Y',
        SearchAvailableSpace: 'Y',
        SearchAirWaybillStock: 'N',
        CreateModifyBookingNew: 'N',
        CreateModifyBookingOld: 'N',
        CreateMultipleBookings: 'N',
        CreateModifyBookingTemplates: 'N',
        CreateRecurringBookingTemplate: 'N',
        CreateSpreadsheetBookings: 'N',
        CreateAirWaybillStockRequest: 'N',
        CreateAllotmentRequest: 'N',
        ViewAllotmentStatus: 'N',
        ViewRateEstimate: 'Y',
        ViewCarrierSchedules: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'Y',
        RetrieveeDocs: 'Y',
        CreateModifyHAWB: 'Y',
        CreateModifyHAWBTemplates: 'Y',
        CreateModifyPieceIDInfo: 'Y',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'Y',
        ViewModifyBooking: 'N',
        ReviewActiveQueuedBookings: 'N',
        PrintBarcodeShippingLabel: 'N',
        PrintShipperLetterOfInstruction: 'N',
        MakeOnlinePayments: 'N',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'Y',
        ViewArchivedAirWaybill: 'Y',
        ShipmentReleaseDeclaration: 'Y',
        Edocs: 'Y',
        MyBookingDocuments: 'Y',
        AirWaybillDocuments: 'Y',
        Efinance: 'Y',
        ViewInvoices: 'Y',
        ViewPaymentDetails: 'Y',
        eClaims: 'Y',
        CreateModifyPreliminaryClaim: 'Y',
        CreateModifyFinalClaim: 'Y',
        ViewACClaimStatus: 'Y',
        ViewAIClaimStatus: 'Y',
        ViewMHClaimStatus: 'Y',
        ViewSKClaimStatus: 'Y'
    }

    const adminConfigKey18: IBranchAdminAuthorizationConfig = {
        isBranchMemberStatus: true,
        isBranchAdministratorStatus: false,
        isCoLoaderStatus: false,
        isBookingAuthorization: false,
        isRateAuthorization: false,
        isAllocationAuthorization: true
    }

    const adminConfigValue18: IBranchAdminPageAccessRights = {
        OfferMenu: 'Y',
        RequestASpotRate: 'Y',
        ACSpotRateOffers: 'Y',
        AISpotRateOffers: 'Y',
        MHSpotRateOffers: 'Y',
        NZSpotRateOffers: 'Y',
        SKSpotRateOffers: 'Y',
        UWSpotRateOffers: 'Y',
        Marketplace: 'N',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'Y',
        SearchAvailableSpace: 'Y',
        SearchAirWaybillStock: 'N',
        CreateModifyBookingNew: 'N',
        CreateModifyBookingOld: 'N',
        CreateMultipleBookings: 'N',
        CreateModifyBookingTemplates: 'N',
        CreateRecurringBookingTemplate: 'N',
        CreateSpreadsheetBookings: 'N',
        CreateAirWaybillStockRequest: 'N',
        CreateAllotmentRequest: 'Y',
        ViewAllotmentStatus: 'Y',
        ViewRateEstimate: 'N',
        ViewCarrierSchedules: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'Y',
        RetrieveeDocs: 'Y',
        CreateModifyHAWB: 'Y',
        CreateModifyHAWBTemplates: 'Y',
        CreateModifyPieceIDInfo: 'Y',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'Y',
        ViewModifyBooking: 'N',
        ReviewActiveQueuedBookings: 'N',
        PrintBarcodeShippingLabel: 'N',
        PrintShipperLetterOfInstruction: 'N',
        MakeOnlinePayments: 'N',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'Y',
        ViewArchivedAirWaybill: 'Y',
        ShipmentReleaseDeclaration: 'Y',
        Edocs: 'Y',
        MyBookingDocuments: 'Y',
        AirWaybillDocuments: 'Y',
        Efinance: 'Y',
        ViewInvoices: 'Y',
        ViewPaymentDetails: 'Y',
        eClaims: 'Y',
        CreateModifyPreliminaryClaim: 'Y',
        CreateModifyFinalClaim: 'Y',
        ViewACClaimStatus: 'Y',
        ViewAIClaimStatus: 'Y',
        ViewMHClaimStatus: 'Y',
        ViewSKClaimStatus: 'Y'
    }

    const adminConfigKey19: IBranchAdminAuthorizationConfig = {
        isBranchMemberStatus: true,
        isBranchAdministratorStatus: false,
        isCoLoaderStatus: false,
        isBookingAuthorization: false,
        isRateAuthorization: false,
        isAllocationAuthorization: false
    }

    const adminConfigValue19: IBranchAdminPageAccessRights = {
        OfferMenu: 'Y',
        RequestASpotRate: 'Y',
        ACSpotRateOffers: 'Y',
        AISpotRateOffers: 'Y',
        MHSpotRateOffers: 'Y',
        NZSpotRateOffers: 'Y',
        SKSpotRateOffers: 'Y',
        UWSpotRateOffers: 'Y',
        Marketplace: 'N',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'Y',
        SearchAvailableSpace: 'Y',
        SearchAirWaybillStock: 'N',
        CreateModifyBookingNew: 'N',
        CreateModifyBookingOld: 'N',
        CreateMultipleBookings: 'N',
        CreateModifyBookingTemplates: 'N',
        CreateRecurringBookingTemplate: 'N',
        CreateSpreadsheetBookings: 'N',
        CreateAirWaybillStockRequest: 'N',
        CreateAllotmentRequest: 'N',
        ViewAllotmentStatus: 'N',
        ViewRateEstimate: 'N',
        ViewCarrierSchedules: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'Y',
        RetrieveeDocs: 'Y',
        CreateModifyHAWB: 'Y',
        CreateModifyHAWBTemplates: 'Y',
        CreateModifyPieceIDInfo: 'Y',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'Y',
        ViewModifyBooking: 'N',
        ReviewActiveQueuedBookings: 'N',
        PrintBarcodeShippingLabel: 'N',
        PrintShipperLetterOfInstruction: 'N',
        MakeOnlinePayments: 'N',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'Y',
        ViewArchivedAirWaybill: 'Y',
        ShipmentReleaseDeclaration: 'Y',
        Edocs: 'Y',
        MyBookingDocuments: 'Y',
        AirWaybillDocuments: 'Y',
        Efinance: 'Y',
        ViewInvoices: 'Y',
        ViewPaymentDetails: 'Y',
        eClaims: 'Y',
        CreateModifyPreliminaryClaim: 'Y',
        CreateModifyFinalClaim: 'Y',
        ViewACClaimStatus: 'Y',
        ViewAIClaimStatus: 'Y',
        ViewMHClaimStatus: 'Y',
        ViewSKClaimStatus: 'Y'
    }

    const adminConfigKey20: IBranchAdminAuthorizationConfig = {
        isBranchMemberStatus: false,
        isBranchAdministratorStatus: true,
        isCoLoaderStatus: false,
        isBookingAuthorization: false,
        isRateAuthorization: true,
        isAllocationAuthorization: true
    }

    const adminConfigValue20: IBranchAdminPageAccessRights = {
        OfferMenu: 'N',
        RequestASpotRate: 'N',
        ACSpotRateOffers: 'N',
        AISpotRateOffers: 'N',
        MHSpotRateOffers: 'N',
        NZSpotRateOffers: 'N',
        SKSpotRateOffers: 'N',
        UWSpotRateOffers: 'N',
        Marketplace: 'N',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'N',
        SearchAvailableSpace: 'N',
        SearchAirWaybillStock: 'N',
        CreateModifyBookingNew: 'N',
        CreateModifyBookingOld: 'N',
        CreateMultipleBookings: 'N',
        CreateModifyBookingTemplates: 'N',
        CreateRecurringBookingTemplate: 'N',
        CreateSpreadsheetBookings: 'N',
        CreateAirWaybillStockRequest: 'N',
        CreateAllotmentRequest: 'N',
        ViewAllotmentStatus: 'N',
        ViewRateEstimate: 'N',
        ViewCarrierSchedules: 'N',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'N',
        RetrieveeDocs: 'N',
        CreateModifyHAWB: 'N',
        CreateModifyHAWBTemplates: 'N',
        CreateModifyPieceIDInfo: 'N',
        ManageShipments: 'Y',
        TrackShipments: 'N',
        SearchAirWaybills: 'N',
        ViewModifyBooking: 'N',
        ReviewActiveQueuedBookings: 'N',
        PrintBarcodeShippingLabel: 'N',
        PrintShipperLetterOfInstruction: 'N',
        MakeOnlinePayments: 'N',
        ViewFlightStatus: 'N',
        ViewCustomsStatus: 'N',
        ViewArchivedAirWaybill: 'N',
        ShipmentReleaseDeclaration: 'N',
        Edocs: 'Y',
        MyBookingDocuments: 'N',
        AirWaybillDocuments: 'N',
        Efinance: 'Y',
        ViewInvoices: 'N',
        ViewPaymentDetails: 'N',
        eClaims: 'Y',
        CreateModifyPreliminaryClaim: 'N',
        CreateModifyFinalClaim: 'N',
        ViewACClaimStatus: 'N',
        ViewAIClaimStatus: 'N',
        ViewMHClaimStatus: 'N',
        ViewSKClaimStatus: 'N'
    }

    const adminConfigKey21: IBranchAdminAuthorizationConfig = {
        isBranchMemberStatus: false,
        isBranchAdministratorStatus: true,
        isCoLoaderStatus: false,
        isBookingAuthorization: true,
        isRateAuthorization: false,
        isAllocationAuthorization: true
    }

    const adminConfigValue21: IBranchAdminPageAccessRights = {
        OfferMenu: 'N',
        RequestASpotRate: 'N',
        ACSpotRateOffers: 'N',
        AISpotRateOffers: 'N',
        MHSpotRateOffers: 'N',
        NZSpotRateOffers: 'N',
        SKSpotRateOffers: 'N',
        UWSpotRateOffers: 'N',
        Marketplace: 'N',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'N',
        SearchAvailableSpace: 'N',
        SearchAirWaybillStock: 'N',
        CreateModifyBookingNew: 'N',
        CreateModifyBookingOld: 'N',
        CreateMultipleBookings: 'N',
        CreateModifyBookingTemplates: 'N',
        CreateRecurringBookingTemplate: 'N',
        CreateSpreadsheetBookings: 'N',
        CreateAirWaybillStockRequest: 'N',
        CreateAllotmentRequest: 'N',
        ViewAllotmentStatus: 'N',
        ViewRateEstimate: 'N',
        ViewCarrierSchedules: 'N',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'N',
        RetrieveeDocs: 'N',
        CreateModifyHAWB: 'N',
        CreateModifyHAWBTemplates: 'N',
        CreateModifyPieceIDInfo: 'N',
        ManageShipments: 'Y',
        TrackShipments: 'N',
        SearchAirWaybills: 'N',
        ViewModifyBooking: 'N',
        ReviewActiveQueuedBookings: 'N',
        PrintBarcodeShippingLabel: 'N',
        PrintShipperLetterOfInstruction: 'N',
        MakeOnlinePayments: 'N',
        ViewFlightStatus: 'N',
        ViewCustomsStatus: 'N',
        ViewArchivedAirWaybill: 'N',
        ShipmentReleaseDeclaration: 'N',
        Edocs: 'Y',
        MyBookingDocuments: 'N',
        AirWaybillDocuments: 'N',
        Efinance: 'Y',
        ViewInvoices: 'N',
        ViewPaymentDetails: 'N',
        eClaims: 'Y',
        CreateModifyPreliminaryClaim: 'N',
        CreateModifyFinalClaim: 'N',
        ViewACClaimStatus: 'N',
        ViewAIClaimStatus: 'N',
        ViewMHClaimStatus: 'N',
        ViewSKClaimStatus: 'N'
    }

    const adminConfigKey22: IBranchAdminAuthorizationConfig = {
        isBranchMemberStatus: false,
        isBranchAdministratorStatus: true,
        isCoLoaderStatus: false,
        isBookingAuthorization: true,
        isRateAuthorization: true,
        isAllocationAuthorization: false
    }

    const adminConfigValue22: IBranchAdminPageAccessRights = {
        OfferMenu: 'N',
        RequestASpotRate: 'N',
        ACSpotRateOffers: 'N',
        AISpotRateOffers: 'N',
        MHSpotRateOffers: 'N',
        NZSpotRateOffers: 'N',
        SKSpotRateOffers: 'N',
        UWSpotRateOffers: 'N',
        Marketplace: 'N',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'N',
        SearchAvailableSpace: 'N',
        SearchAirWaybillStock: 'N',
        CreateModifyBookingNew: 'N',
        CreateModifyBookingOld: 'N',
        CreateMultipleBookings: 'N',
        CreateModifyBookingTemplates: 'N',
        CreateRecurringBookingTemplate: 'N',
        CreateSpreadsheetBookings: 'N',
        CreateAirWaybillStockRequest: 'N',
        CreateAllotmentRequest: 'N',
        ViewAllotmentStatus: 'N',
        ViewRateEstimate: 'N',
        ViewCarrierSchedules: 'N',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'N',
        RetrieveeDocs: 'N',
        CreateModifyHAWB: 'N',
        CreateModifyHAWBTemplates: 'N',
        CreateModifyPieceIDInfo: 'N',
        ManageShipments: 'Y',
        TrackShipments: 'N',
        SearchAirWaybills: 'N',
        ViewModifyBooking: 'N',
        ReviewActiveQueuedBookings: 'N',
        PrintBarcodeShippingLabel: 'N',
        PrintShipperLetterOfInstruction: 'N',
        MakeOnlinePayments: 'N',
        ViewFlightStatus: 'N',
        ViewCustomsStatus: 'N',
        ViewArchivedAirWaybill: 'N',
        ShipmentReleaseDeclaration: 'N',
        Edocs: 'Y',
        MyBookingDocuments: 'N',
        AirWaybillDocuments: 'N',
        Efinance: 'Y',
        ViewInvoices: 'N',
        ViewPaymentDetails: 'N',
        eClaims: 'Y',
        CreateModifyPreliminaryClaim: 'N',
        CreateModifyFinalClaim: 'N',
        ViewACClaimStatus: 'N',
        ViewAIClaimStatus: 'N',
        ViewMHClaimStatus: 'N',
        ViewSKClaimStatus: 'N'
    }

    const adminConfigKey23: IBranchAdminAuthorizationConfig = {
        isBranchMemberStatus: false,
        isBranchAdministratorStatus: true,
        isCoLoaderStatus: false,
        isBookingAuthorization: true,
        isRateAuthorization: false,
        isAllocationAuthorization: false
    }

    const adminConfigValue23: IBranchAdminPageAccessRights = {
        OfferMenu: 'N',
        RequestASpotRate: 'N',
        ACSpotRateOffers: 'N',
        AISpotRateOffers: 'N',
        MHSpotRateOffers: 'N',
        NZSpotRateOffers: 'N',
        SKSpotRateOffers: 'N',
        UWSpotRateOffers: 'N',
        Marketplace: 'N',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'N',
        SearchAvailableSpace: 'N',
        SearchAirWaybillStock: 'N',
        CreateModifyBookingNew: 'N',
        CreateModifyBookingOld: 'N',
        CreateMultipleBookings: 'N',
        CreateModifyBookingTemplates: 'N',
        CreateRecurringBookingTemplate: 'N',
        CreateSpreadsheetBookings: 'N',
        CreateAirWaybillStockRequest: 'N',
        CreateAllotmentRequest: 'N',
        ViewAllotmentStatus: 'N',
        ViewRateEstimate: 'N',
        ViewCarrierSchedules: 'N',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'N',
        RetrieveeDocs: 'N',
        CreateModifyHAWB: 'N',
        CreateModifyHAWBTemplates: 'N',
        CreateModifyPieceIDInfo: 'N',
        ManageShipments: 'Y',
        TrackShipments: 'N',
        SearchAirWaybills: 'N',
        ViewModifyBooking: 'N',
        ReviewActiveQueuedBookings: 'N',
        PrintBarcodeShippingLabel: 'N',
        PrintShipperLetterOfInstruction: 'N',
        MakeOnlinePayments: 'N',
        ViewFlightStatus: 'N',
        ViewCustomsStatus: 'N',
        ViewArchivedAirWaybill: 'N',
        ShipmentReleaseDeclaration: 'N',
        Edocs: 'Y',
        MyBookingDocuments: 'N',
        AirWaybillDocuments: 'N',
        Efinance: 'Y',
        ViewInvoices: 'N',
        ViewPaymentDetails: 'N',
        eClaims: 'Y',
        CreateModifyPreliminaryClaim: 'N',
        CreateModifyFinalClaim: 'N',
        ViewACClaimStatus: 'N',
        ViewAIClaimStatus: 'N',
        ViewMHClaimStatus: 'N',
        ViewSKClaimStatus: 'N'
    }

    const adminConfigKey24: IBranchAdminAuthorizationConfig = {
        isBranchMemberStatus: false,
        isBranchAdministratorStatus: true,
        isCoLoaderStatus: false,
        isBookingAuthorization: false,
        isRateAuthorization: true,
        isAllocationAuthorization: false
    }

    const adminConfigValue24: IBranchAdminPageAccessRights = {
        OfferMenu: 'N',
        RequestASpotRate: 'N',
        ACSpotRateOffers: 'N',
        AISpotRateOffers: 'N',
        MHSpotRateOffers: 'N',
        NZSpotRateOffers: 'N',
        SKSpotRateOffers: 'N',
        UWSpotRateOffers: 'N',
        Marketplace: 'N',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'N',
        SearchAvailableSpace: 'N',
        SearchAirWaybillStock: 'N',
        CreateModifyBookingNew: 'N',
        CreateModifyBookingOld: 'N',
        CreateMultipleBookings: 'N',
        CreateModifyBookingTemplates: 'N',
        CreateRecurringBookingTemplate: 'N',
        CreateSpreadsheetBookings: 'N',
        CreateAirWaybillStockRequest: 'N',
        CreateAllotmentRequest: 'N',
        ViewAllotmentStatus: 'N',
        ViewRateEstimate: 'N',
        ViewCarrierSchedules: 'N',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'N',
        RetrieveeDocs: 'N',
        CreateModifyHAWB: 'N',
        CreateModifyHAWBTemplates: 'N',
        CreateModifyPieceIDInfo: 'N',
        ManageShipments: 'Y',
        TrackShipments: 'N',
        SearchAirWaybills: 'N',
        ViewModifyBooking: 'N',
        ReviewActiveQueuedBookings: 'N',
        PrintBarcodeShippingLabel: 'N',
        PrintShipperLetterOfInstruction: 'N',
        MakeOnlinePayments: 'N',
        ViewFlightStatus: 'N',
        ViewCustomsStatus: 'N',
        ViewArchivedAirWaybill: 'N',
        ShipmentReleaseDeclaration: 'N',
        Edocs: 'Y',
        MyBookingDocuments: 'N',
        AirWaybillDocuments: 'N',
        Efinance: 'Y',
        ViewInvoices: 'N',
        ViewPaymentDetails: 'N',
        eClaims: 'Y',
        CreateModifyPreliminaryClaim: 'N',
        CreateModifyFinalClaim: 'N',
        ViewACClaimStatus: 'N',
        ViewAIClaimStatus: 'N',
        ViewMHClaimStatus: 'N',
        ViewSKClaimStatus: 'N'
    }

    const adminConfigKey25: IBranchAdminAuthorizationConfig = {
        isBranchMemberStatus: false,
        isBranchAdministratorStatus: true,
        isCoLoaderStatus: false,
        isBookingAuthorization: false,
        isRateAuthorization: false,
        isAllocationAuthorization: true
    }

    const adminConfigValue25: IBranchAdminPageAccessRights = {
        OfferMenu: 'N',
        RequestASpotRate: 'N',
        ACSpotRateOffers: 'N',
        AISpotRateOffers: 'N',
        MHSpotRateOffers: 'N',
        NZSpotRateOffers: 'N',
        SKSpotRateOffers: 'N',
        UWSpotRateOffers: 'N',
        Marketplace: 'N',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'N',
        SearchAvailableSpace: 'N',
        SearchAirWaybillStock: 'N',
        CreateModifyBookingNew: 'N',
        CreateModifyBookingOld: 'N',
        CreateMultipleBookings: 'N',
        CreateModifyBookingTemplates: 'N',
        CreateRecurringBookingTemplate: 'N',
        CreateSpreadsheetBookings: 'N',
        CreateAirWaybillStockRequest: 'N',
        CreateAllotmentRequest: 'N',
        ViewAllotmentStatus: 'N',
        ViewRateEstimate: 'N',
        ViewCarrierSchedules: 'N',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'N',
        RetrieveeDocs: 'N',
        CreateModifyHAWB: 'N',
        CreateModifyHAWBTemplates: 'N',
        CreateModifyPieceIDInfo: 'N',
        ManageShipments: 'Y',
        TrackShipments: 'N',
        SearchAirWaybills: 'N',
        ViewModifyBooking: 'N',
        ReviewActiveQueuedBookings: 'N',
        PrintBarcodeShippingLabel: 'N',
        PrintShipperLetterOfInstruction: 'N',
        MakeOnlinePayments: 'N',
        ViewFlightStatus: 'N',
        ViewCustomsStatus: 'N',
        ViewArchivedAirWaybill: 'N',
        ShipmentReleaseDeclaration: 'N',
        Edocs: 'Y',
        MyBookingDocuments: 'N',
        AirWaybillDocuments: 'N',
        Efinance: 'Y',
        ViewInvoices: 'N',
        ViewPaymentDetails: 'N',
        eClaims: 'Y',
        CreateModifyPreliminaryClaim: 'N',
        CreateModifyFinalClaim: 'N',
        ViewACClaimStatus: 'N',
        ViewAIClaimStatus: 'N',
        ViewMHClaimStatus: 'N',
        ViewSKClaimStatus: 'N'
    }

    const adminConfigKey26: IBranchAdminAuthorizationConfig = {
        isBranchMemberStatus: false,
        isBranchAdministratorStatus: true,
        isCoLoaderStatus: false,
        isBookingAuthorization: false,
        isRateAuthorization: false,
        isAllocationAuthorization: false
    }

    const adminConfigValue26: IBranchAdminPageAccessRights = {
        OfferMenu: 'N',
        RequestASpotRate: 'N',
        ACSpotRateOffers: 'N',
        AISpotRateOffers: 'N',
        MHSpotRateOffers: 'N',
        NZSpotRateOffers: 'N',
        SKSpotRateOffers: 'N',
        UWSpotRateOffers: 'N',
        Marketplace: 'N',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'N',
        SearchAvailableSpace: 'N',
        SearchAirWaybillStock: 'N',
        CreateModifyBookingNew: 'N',
        CreateModifyBookingOld: 'N',
        CreateMultipleBookings: 'N',
        CreateModifyBookingTemplates: 'N',
        CreateRecurringBookingTemplate: 'N',
        CreateSpreadsheetBookings: 'N',
        CreateAirWaybillStockRequest: 'N',
        CreateAllotmentRequest: 'N',
        ViewAllotmentStatus: 'N',
        ViewRateEstimate: 'N',
        ViewCarrierSchedules: 'N',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'N',
        RetrieveeDocs: 'N',
        CreateModifyHAWB: 'N',
        CreateModifyHAWBTemplates: 'N',
        CreateModifyPieceIDInfo: 'N',
        ManageShipments: 'Y',
        TrackShipments: 'N',
        SearchAirWaybills: 'N',
        ViewModifyBooking: 'N',
        ReviewActiveQueuedBookings: 'N',
        PrintBarcodeShippingLabel: 'N',
        PrintShipperLetterOfInstruction: 'N',
        MakeOnlinePayments: 'N',
        ViewFlightStatus: 'N',
        ViewCustomsStatus: 'N',
        ViewArchivedAirWaybill: 'N',
        ShipmentReleaseDeclaration: 'N',
        Edocs: 'Y',
        MyBookingDocuments: 'N',
        AirWaybillDocuments: 'N',
        Efinance: 'Y',
        ViewInvoices: 'N',
        ViewPaymentDetails: 'N',
        eClaims: 'Y',
        CreateModifyPreliminaryClaim: 'N',
        CreateModifyFinalClaim: 'N',
        ViewACClaimStatus: 'N',
        ViewAIClaimStatus: 'N',
        ViewMHClaimStatus: 'N',
        ViewSKClaimStatus: 'N'
    }

    const adminConfigKey27: IBranchAdminAuthorizationConfig = {
        isBranchMemberStatus: false,
        isBranchAdministratorStatus: false,
        isCoLoaderStatus: false,
        isBookingAuthorization: false,
        isRateAuthorization: true,
        isAllocationAuthorization: true
    }

    const adminConfigValue27: IBranchAdminPageAccessRights = {
        OfferMenu: 'N',
        RequestASpotRate: 'N',
        ACSpotRateOffers: 'N',
        AISpotRateOffers: 'N',
        MHSpotRateOffers: 'N',
        NZSpotRateOffers: 'N',
        SKSpotRateOffers: 'N',
        UWSpotRateOffers: 'N',
        Marketplace: 'N',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'N',
        SearchAvailableSpace: 'N',
        SearchAirWaybillStock: 'N',
        CreateModifyBookingNew: 'N',
        CreateModifyBookingOld: 'N',
        CreateMultipleBookings: 'N',
        CreateModifyBookingTemplates: 'N',
        CreateRecurringBookingTemplate: 'N',
        CreateSpreadsheetBookings: 'N',
        CreateAirWaybillStockRequest: 'N',
        CreateAllotmentRequest: 'N',
        ViewAllotmentStatus: 'N',
        ViewRateEstimate: 'N',
        ViewCarrierSchedules: 'N',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'N',
        RetrieveeDocs: 'N',
        CreateModifyHAWB: 'N',
        CreateModifyHAWBTemplates: 'N',
        CreateModifyPieceIDInfo: 'N',
        ManageShipments: 'Y',
        TrackShipments: 'N',
        SearchAirWaybills: 'N',
        ViewModifyBooking: 'N',
        ReviewActiveQueuedBookings: 'N',
        PrintBarcodeShippingLabel: 'N',
        PrintShipperLetterOfInstruction: 'N',
        MakeOnlinePayments: 'N',
        ViewFlightStatus: 'N',
        ViewCustomsStatus: 'N',
        ViewArchivedAirWaybill: 'N',
        ShipmentReleaseDeclaration: 'N',
        Edocs: 'Y',
        MyBookingDocuments: 'N',
        AirWaybillDocuments: 'N',
        Efinance: 'Y',
        ViewInvoices: 'N',
        ViewPaymentDetails: 'N',
        eClaims: 'Y',
        CreateModifyPreliminaryClaim: 'N',
        CreateModifyFinalClaim: 'N',
        ViewACClaimStatus: 'N',
        ViewAIClaimStatus: 'N',
        ViewMHClaimStatus: 'N',
        ViewSKClaimStatus: 'N'
    }

    const adminConfigKey28: IBranchAdminAuthorizationConfig = {
        isBranchMemberStatus: false,
        isBranchAdministratorStatus: false,
        isCoLoaderStatus: false,
        isBookingAuthorization: true,
        isRateAuthorization: false,
        isAllocationAuthorization: true
    }

    const adminConfigValue28: IBranchAdminPageAccessRights = {
        OfferMenu: 'N',
        RequestASpotRate: 'N',
        ACSpotRateOffers: 'N',
        AISpotRateOffers: 'N',
        MHSpotRateOffers: 'N',
        NZSpotRateOffers: 'N',
        SKSpotRateOffers: 'N',
        UWSpotRateOffers: 'N',
        Marketplace: 'N',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'N',
        SearchAvailableSpace: 'N',
        SearchAirWaybillStock: 'N',
        CreateModifyBookingNew: 'N',
        CreateModifyBookingOld: 'N',
        CreateMultipleBookings: 'N',
        CreateModifyBookingTemplates: 'N',
        CreateRecurringBookingTemplate: 'N',
        CreateSpreadsheetBookings: 'N',
        CreateAirWaybillStockRequest: 'N',
        CreateAllotmentRequest: 'N',
        ViewAllotmentStatus: 'N',
        ViewRateEstimate: 'N',
        ViewCarrierSchedules: 'N',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'N',
        RetrieveeDocs: 'N',
        CreateModifyHAWB: 'N',
        CreateModifyHAWBTemplates: 'N',
        CreateModifyPieceIDInfo: 'N',
        ManageShipments: 'Y',
        TrackShipments: 'N',
        SearchAirWaybills: 'N',
        ViewModifyBooking: 'N',
        ReviewActiveQueuedBookings: 'N',
        PrintBarcodeShippingLabel: 'N',
        PrintShipperLetterOfInstruction: 'N',
        MakeOnlinePayments: 'N',
        ViewFlightStatus: 'N',
        ViewCustomsStatus: 'N',
        ViewArchivedAirWaybill: 'N',
        ShipmentReleaseDeclaration: 'N',
        Edocs: 'Y',
        MyBookingDocuments: 'N',
        AirWaybillDocuments: 'N',
        Efinance: 'Y',
        ViewInvoices: 'N',
        ViewPaymentDetails: 'N',
        eClaims: 'Y',
        CreateModifyPreliminaryClaim: 'N',
        CreateModifyFinalClaim: 'N',
        ViewACClaimStatus: 'N',
        ViewAIClaimStatus: 'N',
        ViewMHClaimStatus: 'N',
        ViewSKClaimStatus: 'N'
    }

    const adminConfigKey29: IBranchAdminAuthorizationConfig = {
        isBranchMemberStatus: false,
        isBranchAdministratorStatus: false,
        isCoLoaderStatus: false,
        isBookingAuthorization: true,
        isRateAuthorization: true,
        isAllocationAuthorization: false
    }

    const adminConfigValue29: IBranchAdminPageAccessRights = {
        OfferMenu: 'N',
        RequestASpotRate: 'N',
        ACSpotRateOffers: 'N',
        AISpotRateOffers: 'N',
        MHSpotRateOffers: 'N',
        NZSpotRateOffers: 'N',
        SKSpotRateOffers: 'N',
        UWSpotRateOffers: 'N',
        Marketplace: 'N',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'N',
        SearchAvailableSpace: 'N',
        SearchAirWaybillStock: 'N',
        CreateModifyBookingNew: 'N',
        CreateModifyBookingOld: 'N',
        CreateMultipleBookings: 'N',
        CreateModifyBookingTemplates: 'N',
        CreateRecurringBookingTemplate: 'N',
        CreateSpreadsheetBookings: 'N',
        CreateAirWaybillStockRequest: 'N',
        CreateAllotmentRequest: 'N',
        ViewAllotmentStatus: 'N',
        ViewRateEstimate: 'N',
        ViewCarrierSchedules: 'N',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'N',
        RetrieveeDocs: 'N',
        CreateModifyHAWB: 'N',
        CreateModifyHAWBTemplates: 'N',
        CreateModifyPieceIDInfo: 'N',
        ManageShipments: 'Y',
        TrackShipments: 'N',
        SearchAirWaybills: 'N',
        ViewModifyBooking: 'N',
        ReviewActiveQueuedBookings: 'N',
        PrintBarcodeShippingLabel: 'N',
        PrintShipperLetterOfInstruction: 'N',
        MakeOnlinePayments: 'N',
        ViewFlightStatus: 'N',
        ViewCustomsStatus: 'N',
        ViewArchivedAirWaybill: 'N',
        ShipmentReleaseDeclaration: 'N',
        Edocs: 'Y',
        MyBookingDocuments: 'N',
        AirWaybillDocuments: 'N',
        Efinance: 'Y',
        ViewInvoices: 'N',
        ViewPaymentDetails: 'N',
        eClaims: 'Y',
        CreateModifyPreliminaryClaim: 'N',
        CreateModifyFinalClaim: 'N',
        ViewACClaimStatus: 'N',
        ViewAIClaimStatus: 'N',
        ViewMHClaimStatus: 'N',
        ViewSKClaimStatus: 'N'
    }

    const adminConfigKey30: IBranchAdminAuthorizationConfig = {
        isBranchMemberStatus: false,
        isBranchAdministratorStatus: false,
        isCoLoaderStatus: false,
        isBookingAuthorization: true,
        isRateAuthorization: false,
        isAllocationAuthorization: false
    }

    const adminConfigValue30: IBranchAdminPageAccessRights = {
        OfferMenu: 'N',
        RequestASpotRate: 'N',
        ACSpotRateOffers: 'N',
        AISpotRateOffers: 'N',
        MHSpotRateOffers: 'N',
        NZSpotRateOffers: 'N',
        SKSpotRateOffers: 'N',
        UWSpotRateOffers: 'N',
        Marketplace: 'N',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'N',
        SearchAvailableSpace: 'N',
        SearchAirWaybillStock: 'N',
        CreateModifyBookingNew: 'N',
        CreateModifyBookingOld: 'N',
        CreateMultipleBookings: 'N',
        CreateModifyBookingTemplates: 'N',
        CreateRecurringBookingTemplate: 'N',
        CreateSpreadsheetBookings: 'N',
        CreateAirWaybillStockRequest: 'N',
        CreateAllotmentRequest: 'N',
        ViewAllotmentStatus: 'N',
        ViewRateEstimate: 'N',
        ViewCarrierSchedules: 'N',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'N',
        RetrieveeDocs: 'N',
        CreateModifyHAWB: 'N',
        CreateModifyHAWBTemplates: 'N',
        CreateModifyPieceIDInfo: 'N',
        ManageShipments: 'Y',
        TrackShipments: 'N',
        SearchAirWaybills: 'N',
        ViewModifyBooking: 'N',
        ReviewActiveQueuedBookings: 'N',
        PrintBarcodeShippingLabel: 'N',
        PrintShipperLetterOfInstruction: 'N',
        MakeOnlinePayments: 'N',
        ViewFlightStatus: 'N',
        ViewCustomsStatus: 'N',
        ViewArchivedAirWaybill: 'N',
        ShipmentReleaseDeclaration: 'N',
        Edocs: 'Y',
        MyBookingDocuments: 'N',
        AirWaybillDocuments: 'N',
        Efinance: 'Y',
        ViewInvoices: 'N',
        ViewPaymentDetails: 'N',
        eClaims: 'Y',
        CreateModifyPreliminaryClaim: 'N',
        CreateModifyFinalClaim: 'N',
        ViewACClaimStatus: 'N',
        ViewAIClaimStatus: 'N',
        ViewMHClaimStatus: 'N',
        ViewSKClaimStatus: 'N'
    }

    const adminConfigKey31: IBranchAdminAuthorizationConfig = {
        isBranchMemberStatus: false,
        isBranchAdministratorStatus: false,
        isCoLoaderStatus: false,
        isBookingAuthorization: false,
        isRateAuthorization: true,
        isAllocationAuthorization: false
    }

    const adminConfigValue31: IBranchAdminPageAccessRights = {
        OfferMenu: 'N',
        RequestASpotRate: 'N',
        ACSpotRateOffers: 'N',
        AISpotRateOffers: 'N',
        MHSpotRateOffers: 'N',
        NZSpotRateOffers: 'N',
        SKSpotRateOffers: 'N',
        UWSpotRateOffers: 'N',
        Marketplace: 'N',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'N',
        SearchAvailableSpace: 'N',
        SearchAirWaybillStock: 'N',
        CreateModifyBookingNew: 'N',
        CreateModifyBookingOld: 'N',
        CreateMultipleBookings: 'N',
        CreateModifyBookingTemplates: 'N',
        CreateRecurringBookingTemplate: 'N',
        CreateSpreadsheetBookings: 'N',
        CreateAirWaybillStockRequest: 'N',
        CreateAllotmentRequest: 'N',
        ViewAllotmentStatus: 'N',
        ViewRateEstimate: 'N',
        ViewCarrierSchedules: 'N',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'N',
        RetrieveeDocs: 'N',
        CreateModifyHAWB: 'N',
        CreateModifyHAWBTemplates: 'N',
        CreateModifyPieceIDInfo: 'N',
        ManageShipments: 'Y',
        TrackShipments: 'N',
        SearchAirWaybills: 'N',
        ViewModifyBooking: 'N',
        ReviewActiveQueuedBookings: 'N',
        PrintBarcodeShippingLabel: 'N',
        PrintShipperLetterOfInstruction: 'N',
        MakeOnlinePayments: 'N',
        ViewFlightStatus: 'N',
        ViewCustomsStatus: 'N',
        ViewArchivedAirWaybill: 'N',
        ShipmentReleaseDeclaration: 'N',
        Edocs: 'Y',
        MyBookingDocuments: 'N',
        AirWaybillDocuments: 'N',
        Efinance: 'Y',
        ViewInvoices: 'N',
        ViewPaymentDetails: 'N',
        eClaims: 'Y',
        CreateModifyPreliminaryClaim: 'N',
        CreateModifyFinalClaim: 'N',
        ViewACClaimStatus: 'N',
        ViewAIClaimStatus: 'N',
        ViewMHClaimStatus: 'N',
        ViewSKClaimStatus: 'N'
    }

    const adminConfigKey32: IBranchAdminAuthorizationConfig = {
        isBranchMemberStatus: false,
        isBranchAdministratorStatus: false,
        isCoLoaderStatus: false,
        isBookingAuthorization: false,
        isRateAuthorization: false,
        isAllocationAuthorization: true
    }

    const adminConfigValue32: IBranchAdminPageAccessRights = {
        OfferMenu: 'N',
        RequestASpotRate: 'N',
        ACSpotRateOffers: 'N',
        AISpotRateOffers: 'N',
        MHSpotRateOffers: 'N',
        NZSpotRateOffers: 'N',
        SKSpotRateOffers: 'N',
        UWSpotRateOffers: 'N',
        Marketplace: 'N',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'N',
        SearchAvailableSpace: 'N',
        SearchAirWaybillStock: 'N',
        CreateModifyBookingNew: 'N',
        CreateModifyBookingOld: 'N',
        CreateMultipleBookings: 'N',
        CreateModifyBookingTemplates: 'N',
        CreateRecurringBookingTemplate: 'N',
        CreateSpreadsheetBookings: 'N',
        CreateAirWaybillStockRequest: 'N',
        CreateAllotmentRequest: 'N',
        ViewAllotmentStatus: 'N',
        ViewRateEstimate: 'N',
        ViewCarrierSchedules: 'N',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'N',
        RetrieveeDocs: 'N',
        CreateModifyHAWB: 'N',
        CreateModifyHAWBTemplates: 'N',
        CreateModifyPieceIDInfo: 'N',
        ManageShipments: 'Y',
        TrackShipments: 'N',
        SearchAirWaybills: 'N',
        ViewModifyBooking: 'N',
        ReviewActiveQueuedBookings: 'N',
        PrintBarcodeShippingLabel: 'N',
        PrintShipperLetterOfInstruction: 'N',
        MakeOnlinePayments: 'N',
        ViewFlightStatus: 'N',
        ViewCustomsStatus: 'N',
        ViewArchivedAirWaybill: 'N',
        ShipmentReleaseDeclaration: 'N',
        Edocs: 'Y',
        MyBookingDocuments: 'N',
        AirWaybillDocuments: 'N',
        Efinance: 'Y',
        ViewInvoices: 'N',
        ViewPaymentDetails: 'N',
        eClaims: 'Y',
        CreateModifyPreliminaryClaim: 'N',
        CreateModifyFinalClaim: 'N',
        ViewACClaimStatus: 'N',
        ViewAIClaimStatus: 'N',
        ViewMHClaimStatus: 'N',
        ViewSKClaimStatus: 'N'
    }

    const adminConfigKey33: IBranchAdminAuthorizationConfig = {
        isBranchMemberStatus: false,
        isBranchAdministratorStatus: false,
        isCoLoaderStatus: false,
        isBookingAuthorization: false,
        isRateAuthorization: false,
        isAllocationAuthorization: false
    }

    const adminConfigValue33: IBranchAdminPageAccessRights = {
        OfferMenu: 'N',
        RequestASpotRate: 'N',
        ACSpotRateOffers: 'N',
        AISpotRateOffers: 'N',
        MHSpotRateOffers: 'N',
        NZSpotRateOffers: 'N',
        SKSpotRateOffers: 'N',
        UWSpotRateOffers: 'N',
        Marketplace: 'N',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'N',
        SearchAvailableSpace: 'N',
        SearchAirWaybillStock: 'N',
        CreateModifyBookingNew: 'N',
        CreateModifyBookingOld: 'N',
        CreateMultipleBookings: 'N',
        CreateModifyBookingTemplates: 'N',
        CreateRecurringBookingTemplate: 'N',
        CreateSpreadsheetBookings: 'N',
        CreateAirWaybillStockRequest: 'N',
        CreateAllotmentRequest: 'N',
        ViewAllotmentStatus: 'N',
        ViewRateEstimate: 'N',
        ViewCarrierSchedules: 'N',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'N',
        RetrieveeDocs: 'N',
        CreateModifyHAWB: 'N',
        CreateModifyHAWBTemplates: 'N',
        CreateModifyPieceIDInfo: 'N',
        ManageShipments: 'Y',
        TrackShipments: 'N',
        SearchAirWaybills: 'N',
        ViewModifyBooking: 'N',
        ReviewActiveQueuedBookings: 'N',
        PrintBarcodeShippingLabel: 'N',
        PrintShipperLetterOfInstruction: 'N',
        MakeOnlinePayments: 'N',
        ViewFlightStatus: 'N',
        ViewCustomsStatus: 'N',
        ViewArchivedAirWaybill: 'N',
        ShipmentReleaseDeclaration: 'N',
        Edocs: 'Y',
        MyBookingDocuments: 'N',
        AirWaybillDocuments: 'N',
        Efinance: 'Y',
        ViewInvoices: 'N',
        ViewPaymentDetails: 'N',
        eClaims: 'Y',
        CreateModifyPreliminaryClaim: 'N',
        CreateModifyFinalClaim: 'N',
        ViewACClaimStatus: 'N',
        ViewAIClaimStatus: 'N',
        ViewMHClaimStatus: 'N',
        ViewSKClaimStatus: 'N'
    }

    const adminHashMap = new Map<IBranchAdminAuthorizationConfig, IBranchAdminPageAccessRights>()
    adminHashMap.set(adminConfigKey1, adminConfigValue1)
    adminHashMap.set(adminConfigKey2, adminConfigValue2)
    adminHashMap.set(adminConfigKey3, adminConfigValue3)
    adminHashMap.set(adminConfigKey4, adminConfigValue4)
    adminHashMap.set(adminConfigKey5, adminConfigValue5)
    adminHashMap.set(adminConfigKey6, adminConfigValue6)
    adminHashMap.set(adminConfigKey7, adminConfigValue7)
    adminHashMap.set(adminConfigKey8, adminConfigValue8)
    adminHashMap.set(adminConfigKey9, adminConfigValue9)
    adminHashMap.set(adminConfigKey10, adminConfigValue10)
    adminHashMap.set(adminConfigKey11, adminConfigValue11)
    adminHashMap.set(adminConfigKey12, adminConfigValue12)
    adminHashMap.set(adminConfigKey13, adminConfigValue13)
    adminHashMap.set(adminConfigKey14, adminConfigValue14)
    adminHashMap.set(adminConfigKey15, adminConfigValue15)
    adminHashMap.set(adminConfigKey16, adminConfigValue16)
    adminHashMap.set(adminConfigKey17, adminConfigValue17)
    adminHashMap.set(adminConfigKey18, adminConfigValue18)
    adminHashMap.set(adminConfigKey19, adminConfigValue19)
    adminHashMap.set(adminConfigKey20, adminConfigValue20)
    adminHashMap.set(adminConfigKey21, adminConfigValue21)
    adminHashMap.set(adminConfigKey22, adminConfigValue22)
    adminHashMap.set(adminConfigKey23, adminConfigValue23)
    adminHashMap.set(adminConfigKey24, adminConfigValue24)
    adminHashMap.set(adminConfigKey25, adminConfigValue25)
    adminHashMap.set(adminConfigKey26, adminConfigValue26)
    adminHashMap.set(adminConfigKey27, adminConfigValue27)
    adminHashMap.set(adminConfigKey28, adminConfigValue28)
    adminHashMap.set(adminConfigKey29, adminConfigValue29)
    adminHashMap.set(adminConfigKey30, adminConfigValue30)
    adminHashMap.set(adminConfigKey31, adminConfigValue31)
    adminHashMap.set(adminConfigKey32, adminConfigValue32)
    adminHashMap.set(adminConfigKey33, adminConfigValue33)

    return adminHashMap
}
export default AdminPrevilages
